import Select from "react-select";

export const options = [
  { value: "Default", label: "Default" },
  { value: "Home", label: "Home" },
  { value: "Away", label: "Away" },
];

export const rankConfig = {
  leagueType: "college_mens",
  conferenceTeamCount: 0,
};

export const MatchupHomeAwaySelect = ({ homeAwayFilter, setHomeAwayFilter }) => {
  return (
    <Select
      instanceId="matchup-home-away-select"
      id={"matchup-home-away-select"}
      options={options}
      placeholder="select filter"
      value={homeAwayFilter}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: "black",
          color: "white",
          borderColor: state.isFocused ? "white" : baseStyles.borderColor,
          width: "7.5rem",
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          backgroundColor: "black",
          color: "white",
        }),
        option: (baseStyles, { isFocused, isSelected }) => ({
          ...baseStyles,
          backgroundColor: isSelected ? "darkgray" : isFocused ? "gray" : "black",
          color: "white",
        }),
        singleValue: (baseStyles) => ({
          ...baseStyles,
          color: "white",
        }),
      }}
      onChange={(e) => {
        setHomeAwayFilter(e);
      }}
    />
  );
};
